import { PaymentRecord } from "../interfaces/payment-record";
import { createDBServiceSlice } from "./db-service-reducers";

// payments Reducer
export const {
    slice: PaymentsSlice,
    dbThunks: _PaymentsThunks,
    selectByQuery: _paymentsSelectByQuery,
    selectOneObjectByQuery: _paymentsSelectOneObjectByQuery,
    selectOneFieldByQuery: _paymentsSelectOneFieldByQuery,
    selectors: _paymentsSelectors,
    selectByQueryOnlyLength: _paymentsSelectByQueryOnlyLength,
    selectByQueryOnlyMaxMin: _paymentsSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<PaymentRecord>({
    service: "payments",
    initialState: { ids: [], entities: {}, itemsLoaded: false, itemsLoading: false },
    getReducerState: (state) => state.DBPaymentsReducer,
});
export const DBPaymentsReducer = PaymentsSlice.reducer;
export const PaymentsReducerActions = PaymentsSlice.actions;
export type paymentsReducerActions = keyof typeof PaymentsReducerActions;
export const DBPaymentsThunks = _PaymentsThunks;
export const paymentsSelectors = _paymentsSelectors;
export const paymentsSelectByQuery = _paymentsSelectByQuery;
export const paymentsSelectByQueryOnlyLength = _paymentsSelectByQueryOnlyLength;
export const paymentsSelectByQueryOnlyMaxMin = _paymentsSelectByQueryOnlyMaxMin;
export const paymentsSelectOneObjectByQuery = _paymentsSelectOneObjectByQuery;
export const paymentsSelectOneFieldByQuery = _paymentsSelectOneFieldByQuery;